/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

// react
import React from 'react'
import ReactDOM from 'react-dom'
import Cookies from 'cookies-js'

import './extensions.js'

// redux
import { Provider } from 'react-redux'
import store from './store'

// react-router
import { BrowserRouter as Router } from 'react-router-dom'
import Routes from './routes'

// material-ui
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'; // v1.x
import { MuiThemeProvider as V0MuiThemeProvider } from 'material-ui';


import getMuiTheme from 'material-ui/styles/getMuiTheme'

// react-intl
import { IntlProvider } from 'react-intl'
import { locale, messages, language } from './translation'

import registerServiceWorker from './registerServiceWorker'

import './flexboxgrid.min.css'
import './index.css'
import * as colors from 'utils/colors'
import moment from 'moment'
import 'moment/locale/fr'
moment.locale('fr')

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#235585',
    },
  },
  typography: {
    fontFamily: 'IBMPlexSans',
  },
})

const themeV0 = getMuiTheme({
  palette: {
    primary1Color: '#235585',
    accent1Color: '#7b7c7e',
    textColor: '#424242',
    pickerHeaderColor: colors.primary1Color
  },
  fontFamily: 'IBMPlexSans',
})

async function clearCacheStorage() {
  if (!('caches' in window)) {
    console.warn('Cache Storage API not supported')
    return
  }
  try {
    const cacheNames = await caches.keys()
    const deletePromises = cacheNames.map(cacheName => {
      return caches.delete(cacheName)
    })
    const results = await Promise.all(deletePromises)
    if (results.every(deleted => deleted)) {
      console.log('All caches cleared successfully')
    } else {
      console.warn('Some caches could not be cleared')
    }
  } catch (error) {
    console.error('Failed to clear Cache Storage:', error)
  }
}

let jsFileName = Array.from(document.scripts).find(s => s.src && s.src.includes('main'))
jsFileName = jsFileName && jsFileName.src.split('main').slice(-1)[0].split('.').filter(s => s)[0]

if (Cookies.get('jsFileName') !== jsFileName) {
  clearCacheStorage();
  Cookies.set('jsFileName', jsFileName)
}

ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider theme={theme}>
      <V0MuiThemeProvider muiTheme={themeV0}>
        <IntlProvider locale={locale} messages={messages[language]}>
          <React.Fragment>
            <div id="index"></div>
            <Router>
              <Routes />
            </Router>
          </React.Fragment>
        </IntlProvider>
      </V0MuiThemeProvider>
    </MuiThemeProvider>
  </Provider>,
  document.getElementById('root')
)

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js